import React from "react";

const Home = React.lazy(() => import("./views/home/Home"));
const Athletes = React.lazy(() => import("./views/athlete/Athletes"));
const MySubscriptionAthletes = React.lazy(() =>
  import("./views/athlete/MySubscriptionAthletes")
);
const Athlete = React.lazy(() => import("./views/athlete/Athlete"));

const Competition = React.lazy(() => import("./views/competition/Competition"));
const Competitions = React.lazy(() =>
  import("./views/competition/Competitions")
);

const Club = React.lazy(() => import("./views/club/Club"));
const Clubs = React.lazy(() => import("./views/club/Clubs"));

const Group = React.lazy(() => import("./views/group/Group"));
const Groups = React.lazy(() => import("./views/group/Groups"));
const GroupCreate = React.lazy(() => import("./views/group/GroupCreate"));

const Settings = React.lazy(() => import("./views/settings/Settings"));
const PaceCalculator = React.lazy(() => import("./views/tools/PaceCalculator"));
const RacePrediction = React.lazy(() => import("./views/tools/RacePrediction"));

const EventResult = React.lazy(() =>
  import("./views/event_result/EventResult")
);
const routes = [
  {
    path: "/",
    element: Home,
  },

  {
    path: "/clubs",
    element: Clubs,
  },

  {
    path: "/clubs/:id",
    element: Club,
  },
  {
    path: "/groups",
    element: Groups,
  },
  {
    path: "/groups/new",
    element: GroupCreate,
  },
  {
    path: "/groups/:id",
    element: Group,
  },
  {
    path: "/groups/:id/:tab",
    element: Group,
  },
  {
    exact: true,
    path: "/athletes",
    element: Athletes,
  },
  {
    path: "/athletes/subscriptions",
    element: MySubscriptionAthletes,
  },
  {
    path: "/athletes/:id",
    element: Athlete,
  },
  {
    path: "/athletes/:id/:tab",
    element: Athlete,
  },
  {
    path: "/competitions",
    element: Competitions,
  },
  {
    path: "/competitions/:id",
    element: Competition,
  },
  {
    path: "/competitions/:id/:event_id",
    element: Competition,
  },
  {
    path: "/settings/:page",
    element: Settings,
  },
  {
    path: "/settings/",
    element: Settings,
  },
  {
    path: "/tools/pace-calculator",
    element: PaceCalculator,
  },
  {
    path: "/tools/race-prediction",
    element: RacePrediction,
  },
  {
    path: "/event-results/:id",
    element: EventResult,
    title: "Résultat",
  },
];

export default routes;
